module.exports = __webpack_public_path__ + "static/media/notification.9f7412f0.svg";